<div class="chart-modal">
  <!-- Header row -->
  <div class="chart-modal__header">
    <!-- Left: Title -->
    <div class="title-section">
      <h3 class="chart-title">{{ title | transloco }}</h3>
    </div>

    <!-- Right: Filters + menu + close -->
    <div class="chart-modal__header-actions">
      <div class="filters d-flex align-items-center gap-2">
        <app-make-model-filter
          [filter]="makeModelFilter"
          [accountFilterChanged$]="accountIdsChanged$"
          (filterChanged)="onMakeModelFilterChange($event)">
        </app-make-model-filter>

        <app-account-filter
          [filter]="accountFilter"
          (filterChanged)="onAccountFilterChange($event)">
        </app-account-filter>

        <div class="common-drop-down date-height">
          <app-date-filter
            [filter]="dateFilter"
            [isButtonIntervalSelector]="false"
            [disabledIntervals]="disabledIntervals"
            [defaultInterval]="defaultInterval"
            (filterChanged)="onDateFilterChange($event)">
          </app-date-filter>
        </div>
      </div>

      <!-- close -->
      <button type="button" class="icon-btn" [attr.aria-label]="'common.close' | transloco" (click)="close()">
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" aria-hidden="true">
          <path
            d="M18 6L6 18M6 6l12 12"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round">
          </path>
        </svg>
      </button>
    </div>
  </div>

  <!-- Chart area -->
  <div class="chart-modal__body">
    @defer (on timer(100ms)) {
      @if (!isLoading && hasData()) {
        <div class="chart-modal__chart">
          <div class="timeline-chart">
            <!-- Y-axis labels (category names) -->
            <div class="y-axis-labels">
              @for (category of categories; track category.name) {
                <div class="y-axis-label">{{ displayLabel(category.name) }}</div>
              }
            </div>

            <!-- Chart content area -->
            <div class="chart-content">
              <!-- Vertical grid lines -->
              <div class="grid-lines">
                @for (label of xAxisLabels; track $index) {
                  <div class="grid-line" [style.left.%]="getXAxisLabelPosition($index)"></div>
                }
              </div>

              <!-- Timeline rows -->
              <div class="timeline-rows">
                @for (category of categories; track category.name) {
                  <div class="timeline-row">
                    <div class="timeline-bar-track">
                      <div
                        class="timeline-bar-fill"
                        [style.width.%]="category.endPercent"
                        [style.background-color]="category.color">
                      </div>
                    </div>
                  </div>
                }
              </div>

              <!-- X-axis -->
              <div class="x-axis">
                @for (label of xAxisLabels; track $index) {
                  <div class="x-axis-label" [style.left.%]="getXAxisLabelPosition($index)">
                    {{ label }}
                  </div>
                }
              </div>
            </div>
          </div>
        </div>
      } @else if (!isLoading && !hasData()) {
        <div class="chart-modal__empty">
          <app-empty-state></app-empty-state>
        </div>
      }
    }

    @if (isLoading) {
      <div class="chart-modal__loader">
        <div class="spinner-border text-primary" role="status"></div>
      </div>
    }
  </div>
</div>